import { render, staticRenderFns } from "./promotermsandconditions.vue?vue&type=template&id=88322ac8&"
import script from "./promotermsandconditions.vue?vue&type=script&lang=js&"
export * from "./promotermsandconditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports